<template>
  <div class="d-flex justify-space-between align-top sm-gap">
    <div class="d-flex flex-column">
      <div>
        <u>Mode de livraison:</u>
      </div>
      <div v-if="infos.mode == 'retrait'">Retrait sur place</div>
      <div v-if="infos.mode == 'point_relai'">
        <div>Livraison en relai Pickup</div>
        <div class="font-italic" v-html="infos.adresse_point_relai.replace(/\n/g, '<br />')"></div>
      </div>
    </div>

    <div class="justify-self-end text-body font-weight-bold">
      <span v-if="infos.price">{{ infos.price }}€</span><span v-else>Gratuit</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["infos"],
};
</script>

<style lang="scss" scoped></style>